import React from "react";
import { InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import AccomplishmentReportPresenter from "./AccomplishmentReportPresenter";
import InputFactory from "../../../../components/InputFactory";
import { FloatingForm } from "../../../../components/common/Converter";
import { createNotification } from "../../../../createNotification";
import Progress from "../../../../components/Progress";

class AccomplishmentReport extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AccomplishmentReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      isViewOpen: false,
      title: "",
      description: "",
      stats: "",
      activities: "",
      activitiesArray: [],
      selectedFiles: [],
      accomplishmentTitle: "",
      username: "",
      objectID: "",
      employee: {},
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "accomplishment_report";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handleObjectData(data) {
    console.log("DATA: ", data);
    const query = {
      where: {
        id: data.id,
      },
    };
    const accomplishment = await findObjectUseCase().execute(
      "accomplishment_report",
      query
    );

    for (const object of accomplishment) {
      // console.warn("OBEJCT: ", object);
      this.setState({
        isViewOpen: true,
        title: object.title || "",
        accomplishmentTitle: object.accomplishmentTitle || "",
        description: object.description || "",
        stats: object.stats || "",
        activities: object.activities || "",
        activitiesArray: object.activitiesArray || [],
        selectedFiles: object.selectedFiles || [],
        username: object.username || "",
        objectID: object.id,
        employee: { id: object.employee.id },
      });
    }
  }

  async handleSaveAccomplishment() {
    const {
      accomplishmentTitle,
      title,
      description,
      activitiesArray,
      selectedFiles,
      objectID,
      username,
      employee,
    } = this.state;
    const data = {
      title,
      accomplishmentTitle,
      description,
      username,
      activities: activitiesArray,
      stats: "Approved",
      selectedFiles,
    };

    this.setState({ isViewOpen: false });
    // alert("Commendation Details");
    await upsertUseCase().execute("accomplishment", data);
    await upsertUseCase().execute("accomplishment_profile", {
      employee,
      ...data,
    });
    await deleteObjectUseCase().execute("accomplishment_report", objectID);
    this.showSuccess(
      "The accomplishment report has been successfully acknowledged."
    );

    //  CREATE NOTIFICATION
    const NOTIFICATION_MESSAGE = `Your accomplishment report has been successfully acknowledged.`;
    const NOTIFICATION_RECEIVER = [employee.id];
    const NOTIFICATION_REDIRECT = "accomplishments";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );
    this.refetchData();
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      loading,
      isViewOpen,
      activitiesArray,
      current,
      count,
      limit,
    } = this.state;
    if (!schema) return <Progress />;
    // const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];

    // const isImageUrl = (file) => {
    //   const extension = file.split(".").pop().toLowerCase();
    //   return imageExtensions.includes(`.${extension}`);
    // };
    // const empPointer = objects
    //   .filter((item) => typeof item.employee === "object")
    //   .map((item) => item.employee);
    return (
      <>
        <div>
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div className="mb-3">
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>
            </div>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">{schema.label}</h4>
                </div>
              </CardView>

              <Table
                // empPointer={empPointer}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleObjectData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "username"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {isViewOpen && (
          <>
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">
                  Accomplishment Report
                </h4>
                <hr />
                <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                  <div className="mb-4">
                    {["Title", "Description", "Stats"].map((label, index) => (
                      <>
                        <label className="mb-2" key={index}>
                          {label} <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-12 mb-4">
                          <InputFactory
                            disabled={true}
                            type={label === "Description" ? "Text" : "String"}
                            value={this.state[label.toLowerCase()]}
                          />
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="mb-4">
                    <label className="mb-2">
                      Activities <span className="text-danger">*</span>
                    </label>
                    {activitiesArray.map((label, index) => (
                      <div className="col-lg-12 mb-2" key={index}>
                        <InputFactory
                          type="String"
                          value={label}
                          disabled={true}
                        />
                      </div>
                    ))}
                  </div>

                  {this.state.selectedFiles.length > 0 && (
                    <div className="d-grid">
                      <label className="mb-2">File Attachment</label>
                      <div className="d-flex gap-2">
                        {this.state.selectedFiles.map((item, index) => {
                          const itemName = item.split("_");
                          return (
                            <>
                              <a
                                key={index}
                                href={item}
                                target="blank"
                                rel="noopener"
                              >
                                {itemName[1]}
                              </a>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <hr />
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <button
                    className="btn btn-light"
                    onClick={() => this.setState({ isViewOpen: false })}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleSaveAccomplishment.bind(this)}
                  >
                    Approve
                  </button>
                </div>
              </CardView>
            </FloatingForm>
          </>
        )}
      </>
    );
  }
}

export default withRouter(AccomplishmentReport);
